import { ReactNode, useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  listWrapper: {
    height: '100%',
  },
}));

type Props = {
  children: ReactNode;
  className?: string;
  initHeight?: number;
  isDisabled?: boolean;
};

export const VirtualizationWrapper = (props: Props) => {
  const classes = useStyles();
  const { isDisabled, children, initHeight, className } = props;

  const [height, setHeight] = useState(initHeight);
  const { ref, inView } = useInView({
    threshold: 0,
  });
  const listWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const divRefClone = listWrapperRef;

    const resize = new ResizeObserver((entries) => {
      if (inView && entries[0]) {
        const height = entries[0].target?.clientHeight;
        setHeight(height);
      }
    });
    if (divRefClone.current) {
      resize.observe(divRefClone.current);
    }
    return () => {
      if (divRefClone.current) {
        resize.unobserve(divRefClone.current);
      }
    };
  }, [inView]);

  return (
    <div ref={ref} style={{ minHeight: height, height: '100%' }} className={className}>
      <div className={classes.listWrapper} ref={listWrapperRef}>
        {isDisabled || inView ? children : <></>}
      </div>
    </div>
  );
};
